<div class="error-page-not-found">
  <div class="loading-logo"></div>
  <p class="error-info">No Such page yet exists!</p>
  <p class="error-redirect">
    Click <a routerLink="/">Here</a> to Redirect to Home Page
  </p>
</div>
